/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-25 21:40:02
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-29 19:40:03
 */
const ranking = [
	{
		path: '/ranking',
		component: null,
		name: '排行榜',
		id: 2,
		parentId: 0,
		keepAlive: false,
		showBread: false,
		visible: false,
		useTemplate: false,
		redirect: '/ranking/issueTalent',
		children: [
			{
				path: 'issueTalent',
				component: null,
				name: '出单达人',
				parentId: 2,
				id: 10,
				keepAlive: false,
				showBread: true,
				visible: true,
				useTemplate: false,
				redirect: '/ranking/issueTalent/list',
				children: [
					{
						path: 'list',
						component: 'ranking/issueTalent/list',
						parentId: 10,
						keepAlive: false,
						name: '出单达人列表',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'record',
						component: 'shopManage/orderDetails/record',
						name: '导出记录',
						parentId: 10,
						keepAlive: false,
						showBread: true,
						visible: false,
						useTemplate: true,
					},
				],
			},
			{
				path: 'issueHeader',
				component: null,
				name: '出单二级团长',
				parentId: 2,
				id: 11,
				keepAlive: false,
				showBread: true,
				visible: true,
				useTemplate: false,
				redirect: '/ranking/issueHeader/list',
				children: [
					{
						path: 'list',
						component: 'ranking/issueHeader/list',
						parentId: 10,
						keepAlive: false,
						name: '出单二级团长列表',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'record',
						component: 'shopManage/orderDetails/record',
						name: '导出记录',
						parentId: 10,
						keepAlive: false,
						showBread: true,
						visible: false,
						useTemplate: true,
					},
				],
			},
			{
				path: 'issueProduct',
				component: null,
				name: '出单商品',
				parentId: 2,
				id: 11,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/ranking/issueProduct/list',
				children: [
					{
						path: 'list',
						parentId: 11,
						keepAlive: false,
						component: 'ranking/issueProduct/list',
						name: '出单商品列表',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'record',
						component: 'shopManage/orderDetails/record',
						name: '导出记录',
						parentId: 10,
						keepAlive: false,
						showBread: true,
						visible: false,
						useTemplate: true,
					},
				],
			},
		],
	},
];
export default ranking;
